import Skeleton from '@mui/material/Skeleton';
import React from 'react';

import type { SideNavs } from '@swf/help';
import { SkeletonList } from '@swf/help';

import styles from './SideBar.scss';

interface Props {
  title: React.ReactNode;
  sideNavs: SideNavs[];
  categoryId?: string;
}

const SideBar: React.FC<Props> = ({ title, sideNavs, categoryId }) => (
  <div className={styles.container}>
    <h2 className={styles.title}>{title}</h2>
    <ul className={styles.list}>
      {sideNavs.map(({ id, element }, index) => (
        <li key={index} className={id === categoryId ? styles.highlight : 'none'}>
          {element}
        </li>
      ))}
    </ul>
  </div>
);

export const SideBarSkeleton = () => (
  <div className={styles.container}>
    <Skeleton className={styles.title} variant="rectangular" width={165} height={26} />
    <SkeletonList
      className={styles.list}
      skeletonSizes={['110px', '190px', '100px', '140px', '135px', '170px', '150px', '120px']}
      height={17}
    />
  </div>
);

export default SideBar;
